import React, {Fragment} from 'react';
import connect from "react-redux/es/connect/connect";
import {load} from "../../actions/logbookAction";
import {translate} from "react-i18next";
import moment from "moment";
import LogbookApi from "../../apis/LogbookApi";
import reactStringReplace from "react-string-replace";

class Comment extends React.Component {

    state = {
        startDelete: false,
        deleted: false,
        editing: false,
        editLoading: false,
        editMessage: '',
        editErrors: {}
    };

    deleteComment = () => {
        this.setState({deleted: true});
        LogbookApi.deleteComment(this.props.comment.id);
    };

    editComment = (e) => {
        e.preventDefault();
        this.setState({editLoading: true, editErrors: {}});
        LogbookApi.editComment(this.props.comment.id, {
            message: this.state.editMessage
        }).then((result) => {
            if (result.data.success === true) {
                this.setState({
                    message: this.state.editMessage,
                    editLoading: false,
                    editing: false
                });
            } else {
                this.setState({
                    editErrors: result.data.errors,
                    editLoading: false
                });
            }
        });
    };

    render() {
        const { authorization, t } = this.props;
        return !this.state.deleted ? (
            <div className="comment row">
                {this.state.editing ? (
                    <form onSubmit={this.editComment} className="col-xs-12">
                        <div
                            className={"form-group" + ((this.state.editErrors && this.state.editErrors.message) ? ' has-error' : '')}>
                            <label>
                                {t('logbook.comment.message')}
                            </label>
                            <textarea className="form-control" value={this.state.editMessage}
                                      onChange={(e) => this.setState({editMessage: e.target.value})}
                                      disabled={this.state.loading}/>
                            {(this.state.editErrors && this.state.editErrors.message) ? (
                                <span className="help-block">
                                                {t('logbook.comment.error.' + this.state.editErrors.message)}
                            </span>
                            ) : null}
                        </div>
                        <div className="button-container text-right">
                            <div className="btn-group">
                                <button type="cancel" className="btn btn-sm btn-default"
                                        disabled={this.state.editLoading} onClick={() => this.setState({
                                    editErrors: {},
                                    editMessage: this.state.message,
                                    editing: false
                                })}>
                                    <i className="fa fa-close m-r-xs"/>{t('default.cancel')}
                                </button>
                                <button type="submit" className="btn btn-sm btn-primary"
                                        disabled={this.state.editLoading}>
                                    <i className={`fa fa-${this.state.editLoading ? 'spin fa-spinner' : 'save'} m-r-xs`}/> {t('default.save')}
                                </button>
                            </div>
                        </div>
                    </form>
                ) : (
                    <Fragment>
                        <div className="col-xs-2">
                            <i className={`fa fa-${this.props.comment.type === 'comment' ? 'comment' : 'wrench'}`}/> <small className="text-muted">{this.props.comment.createdBy.username}<br/>
                            {moment(this.props.comment.createdAt).format('DD.MM. HH:mm')}</small>
                        </div>
                        <div className="col-xs-10">
                            <div className="menu-container pull-right text-right">
                                {this.props.comment.type === 'comment' && this.props.comment.createdBy.username === authorization.username ? (
                                    <Fragment>
                                        <button className="btn btn-xs no-borders btn-outline btn-primary" type="default"
                                                onClick={() => this.setState({editing: true, editMessage: this.props.comment.message})}>
                                            <i className="fa fa-pencil"/>
                                        </button>
                                        <button className="btn btn-xs no-borders btn-outline btn-danger" type="default"
                                                onClick={() => this.setState({startDelete: true})}>
                                            <i className="fa fa-trash"/>
                                        </button>
                                    </Fragment>
                                ) : null}
                            </div>
                            {this.state.editMessage ? this.state.editMessage :
                                reactStringReplace(this.props.comment.message, /#(\w+)/g, (match, i) => (
                                    <span className="hashtag" key={match + i}
                                          onClick={() => this.props.setSearchInformation(`#${match}`)}>#{match}</span>
                                ))
                            }
                        </div>
                        <div className="col-xs-12">
                            {this.state.startDelete ? (
                                <div className="m-t-md">
                                    <div className="text-danger">
                                        {t('logbook.comment.reallyDelete')}
                                    </div>
                                    <div className="btn-group m-t-xs">
                                        <button type="cancel" className="btn btn-default btn-xs"
                                                onClick={() => this.setState({startDelete: false})}>
                                            <i className="fa fa-close m-r-xs"/>
                                            {t('default.cancel')}
                                        </button>
                                        <button type="default" className="btn btn-danger btn-xs"
                                                onClick={this.deleteComment}>
                                            <i className="fa fa-trash m-r-xs"/>
                                            {t('default.delete')}
                                        </button>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </Fragment>
                )}
            </div>
        ) : null
    }
}

const mapStateToProps = state => ({
    logbook: state.logbook,
    authorization: state.authorization
});

export default connect(mapStateToProps, {
    load
})(translate()(Comment));
